import { render, staticRenderFns } from "./Pupils.vue?vue&type=template&id=d45dd9e8"
import script from "./Pupils.vue?vue&type=script&lang=js"
export * from "./Pupils.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports